import { AppRouteProps } from "@harea/component";
import React from "react";

const HierarchyTabsContainer = React.lazy(
  () => import("./container/HierarchyTabsContainer")
);

export const HierarchyRoutes: Array<AppRouteProps> = [
  {
    path: "hierarchy",
    title: "BSMRH.Organigram.Title",    
    element: <HierarchyTabsContainer />,
  },
];
